import { combineReducers } from 'redux';

import account from './account/reducer';
import security from './security/reducer';

export default combineReducers({
  account,
  security,
});
